import { APP_SCHEME, STATION_DOMAIN, VOTE_DOMAIN, VOTE_PROTOCAL_DOMAIN } from "constant/config";
import { isSupportPlayStoreInApp } from "helpers";
import { STYPE_HASHTAG } from "constant/log";
import { HASHTAGS } from "constant/search";
import { isImageOpenAllowed, isWebview } from "helpers";
import { searchLog } from "libs/searchLogCollection";
import { addVoteIFrame } from "libs/VoteFrame";
import React, { useCallback, useEffect, useRef } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router";
import useCheckHiddenFunc from "components/hook/useCheckHiddenFunc";
import cookie from "react-cookies";

const PostBody = () => {
    const history = useHistory();

    const contentRef = useRef(null);
    const offsetWidth = useRef(null);
    // 게시글 정보 조회
    const { content, hashtags, photos } = useSelector(({ postReducer }) => {
        const { data = {} } = postReducer;
        const { content: contentData, hashtags: hashtagsData, photos } = data;
        const { content = "" } = contentData || {};
        const { hashtags = [] } = hashtagsData || {};
        return {
            content,
            hashtags,
            photos,
        };
    }, shallowEqual);

    useEffect(() => {
        // DOM에서 img태그가 있는 경우 data-photo-exist 속성 추가
        if (contentRef.current) {
            const imgElements = contentRef.current.querySelectorAll("img");
            imgElements.forEach((imgElement) => {
                const photoExists = photos.some((photo) => photo.url === imgElement.getAttribute("src"));

                if (photoExists) {
                    imgElement.setAttribute("data-photo-exist", "true");
                } else {
                    imgElement.setAttribute("data-photo-exist", "false");
                }
            });
        }
    }, [content]);

    // 채널 정보 조회
    const stationError = useSelector(({ stationReducer }) => {
        const { stationInfo = {} } = stationReducer;
        const { error = null } = stationInfo;
        return error;
    });

    // 투표 팝업 메시지
    const receiveVoteMessage = (event) => {
        // 두 도메인 변수를 합쳐서 정규식 패턴을 생성
        const re = new RegExp(`(${VOTE_PROTOCAL_DOMAIN}|${VOTE_DOMAIN})`, "i");

        if (!event.origin.match(re)) return;

        const theme = cookie.load("theme");
        addVoteIFrame(event.source);
        const { id, height } = event.data;
        let vote = document.getElementById(`vote${id}`);
        vote.contentWindow.postMessage({ action: "darkMode", value: theme === "dark" }, VOTE_PROTOCAL_DOMAIN);
        if (vote) vote.height = height;
    };

    //히든 키워드 체크
    const { regAtagHiddenKeyword, hiddenKeywordCallFunc } = useCheckHiddenFunc();

    // 이미지 리사이징
    const handleImageResize = useCallback((event) => {
        const element = event.target;

        let attrWidth = element.getAttribute("width") || element.style.width;
        let attrHeight = element.getAttribute("height") || element.style.height;
        attrWidth = attrWidth.replace("px", "");
        attrHeight = attrHeight.replace("px", "");

        if (element.nodeName === "IFRAME") {
            if (element.offsetWidth !== attrWidth) {
                const attrRatio = attrWidth / attrHeight;
                if (attrRatio) {
                    element.height = element.offsetWidth / attrRatio; //지정한 비율로 높이 조정
                }
            }
        } else {
            if (element.offsetWidth && attrHeight !== null && attrHeight !== "") {
                const renderRatio = element.width / element.height;
                const attrRatio = attrWidth / attrHeight;

                //가로가 max-width=100% 적용받았을 경우
                if (element.offsetWidth <= element.width) {
                    if (attrRatio && renderRatio !== attrRatio) {
                        element.height = element.width / attrRatio; //지정한 비율로 높이 조정
                    } else {
                        element.removeAttribute("height");
                    }
                    element.style.height = "";
                    element.setAttribute("data-width", attrWidth);
                    element.setAttribute("data-height", attrHeight);
                }
            }
        }
    }, []);

    // 글보기 초기 세팅
    useEffect(() => {
        const contentRefDom = contentRef.current;
        offsetWidth.current = contentRefDom.offsetWidth;
        contentRefDom.addEventListener("load", handleImageResize, true);
        window.addEventListener("message", receiveVoteMessage);

        return () => {
            contentRefDom.removeEventListener("load", handleImageResize);
            window.removeEventListener("message", receiveVoteMessage);
        };
    }, [handleImageResize]);

    /**
     * 해쉬 태그 검색
     * @param hashtag
     * @returns {function(...[*]=)}
     */
    const handleClickHashtag = (hashtag) => (event) => {
        event.preventDefault();

        if (stationError) {
            alert("해당 채널에서는 채널 검색을 이용하실 수 없습니다.\n통합 검색을 이용해주세요.");
            return false;
        }

        const field = HASHTAGS,
            keyword = hashtag;

        // 해쉬 태그 검색 로그
        searchLog({ keyword, filter: field, searchType: STYPE_HASHTAG });

        history.push(`/${global.bj_id}/search?keyword=${keyword}&field=${field}`, { searchType: STYPE_HASHTAG });
    };

    /**
     * 모바일 게시물이미지 클릭 VIEW
     */
    const handlePopupImage = useCallback(
        (e) => {
            if (e.target.tagName === "IMG" && isImageOpenAllowed()) {
                let parentNode = e.target.parentNode;
                let bLink = false;
                //부모들중에 링크가 있는지 체크
                while (parentNode !== e.currentTarget) {
                    if (parentNode.tagName === "A") {
                        bLink = true;
                        break;
                    }
                    parentNode = parentNode.parentNode;
                }
                //링크가 안걸려있고
                if (!bLink) {
                    const imageSrc = STATION_DOMAIN + "/image/detail_image.html?src=" + window.encodeURIComponent(e.target.src);
                    window.open(imageSrc);
                }
            }
            if (e.target.tagName === "IMG" && e.target.className === "ogq_item") {
                e.preventDefault();
                // 안드로이드 웹뷰 6.13.3 이상 앱 버전 플레이스토어 설치 된 경우 ogq 마켓 미노출
                if (isSupportPlayStoreInApp()) {
                    return;
                }
                if (isWebview) {
                    window.location.href = `${APP_SCHEME}browser/external?url=${encodeURIComponent(e.target.parentNode.href)}`;
                } else {
                    window.open(e.target.parentNode.href);
                }
            }
            // RegExp A tag Search hidden keyword
            // 히든 키워드 조회해서 Redirect 동작
            if (e.target.tagName === "A") {
                const aCallHiddenData = regAtagHiddenKeyword(e.target.getAttribute("href"));
                if (aCallHiddenData.hiddenFlag) {
                    e.preventDefault();
                    hiddenKeywordCallFunc(aCallHiddenData);
                }
            }
        },
        [regAtagHiddenKeyword, hiddenKeywordCallFunc],
    );

    return (
        <section className="post_detail">
            <div className="txt_box" onClick={handlePopupImage} ref={contentRef} dangerouslySetInnerHTML={{ __html: content }} />

            {/* 해쉬 태그 노출 */}
            <div className="hash_tags_view">
                {hashtags.map((hashtag) => (
                    <button type="button" onClick={handleClickHashtag(hashtag)} key={hashtag}>
                        {hashtag}
                    </button>
                ))}
            </div>
        </section>
    );
};

export default PostBody;

